import { render, staticRenderFns } from "./ReportedErrors.vue?vue&type=template&id=9a63365c&"
import script from "./ReportedErrors.vue?vue&type=script&lang=js&"
export * from "./ReportedErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports